import React, { Fragment } from "react";
import { Container, Row, Col } from "reactstrap";

const Footer = () => {
  return (
    <Fragment>
      <footer className="footer">
        <Container fluid={true}>
          <Row>
            <Col md={6}>{new Date().getFullYear()} © Rombo Logística</Col>
            <Col md={6}>
              <div className="text-sm-end d-none d-sm-block">
                S.A de C.V
              </div>
            </Col>  
          </Row>
        </Container>
      </footer>
    </Fragment>
  )
}

export default Footer
